import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { ProxyUserRequest, ProxyUserRequestResponse } from '../../models/proxy-user-request';

@Injectable({
  providedIn: 'root',
})
export class ProxyUserRequestsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  proxyUserRequestsEndpoint = this.config.patientApiUrl + '/v1/PatientPortalProxyUserRequests';

  /**
   * Posts a signed proxy-access authorization.
   *
   * `skipGlobalError` is deliberate: without it `ErrorInterceptor` dispatches
   * `setGlobalError` and the app navigates to `/error`, discarding a fully typed and signed
   * authorization the user cannot get back. The caller renders the failure inline instead and leaves
   * the form intact so it can be resubmitted.
   */
  insertProxyUserRequest(request: ProxyUserRequest): Observable<ProxyUserRequestResponse> {
    return this.utilityService.postRequest<ProxyUserRequestResponse>(this.proxyUserRequestsEndpoint, request, {
      skipGlobalError: true,
    });
  }
}
